var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbListPhoto = function SvgThumbListPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2.25H3.75c-.825 0-1.5.675-1.5 1.5v10.5c0 .825.675 1.5 1.5 1.5h10.5c.825 0 1.5-.675 1.5-1.5V3.75c0-.825-.675-1.5-1.5-1.5Zm-.75 12h-9a.752.752 0 0 1-.75-.75v-9c0-.412.338-.75.75-.75h9c.412 0 .75.338.75.75v9c0 .412-.338.75-.75.75Zm-3.33-4.643-1.762 2.266-1.17-1.41a.375.375 0 0 0-.586.007l-1.304 1.672a.376.376 0 0 0 .292.608h6.735a.375.375 0 0 0 .3-.6l-1.913-2.543a.373.373 0 0 0-.592 0Z",
    fill: "#58B847"
  })));
};
export default SvgThumbListPhoto;